import { normalizarData, normalizarValor } from '../../utils';

/**
 * Retorna TRUE se o array de dados (Sheet->JSON) se parecer com
 * um arquivo de Extrato da Sicredi.
 */
export const detectar = (dadosArray) => {
    // Tentar diferentes formas de encontrar o cabeçalho "DATA" e "VALOR"
    for (let i = 0; i < Math.min(dadosArray.length, 20); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;
        
        const linhaStr = linha.map(cell => String(cell || '').toUpperCase()).join(' ');
        
        // Se verificar que tem DATA e VALOR na mesma linha, e NÃO começa com 'EXTRATO CONTA CORRENTE' (Sicoob)
        if (linhaStr.includes('DATA') && linhaStr.includes('VALOR') && dadosArray[0] && Array.isArray(dadosArray[0]) && String(dadosArray[0][0]).trim() !== 'EXTRATO CONTA CORRENTE') {
            return true;
        }
    }
    return false;
};

/**
 * Processa a planilha bruta e retorna array mapeado.
 */
export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let idxData = -1;
    let idxValor = -1;
    let idxDescricao = -1;
      
    // Encontrar cabeçalho - lógica legada portada
    for (let i = 0; i < Math.min(dadosArray.length, 20); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;
        
        const linhaStr = linha.map(cell => String(cell || '').toUpperCase().trim());
        
        const possibleDataIdx = linhaStr.findIndex(cell => cell === 'DATA' || cell === 'DATE' || cell.includes('DATA'));
        const possibleValorIdx = linhaStr.findIndex(cell => cell === 'VALOR' || cell === 'VALUE' || cell.includes('VALOR'));
        const possibleDescricaoIdx = linhaStr.findIndex(cell => cell.includes('DESCRI') || cell.includes('HIST') || cell.includes('LANÇAMENTO') || cell.includes('LANCAMENTO'));

        if (possibleDataIdx !== -1 && possibleValorIdx !== -1) {
            idxCabecalho = i;
            idxData = possibleDataIdx;
            idxValor = possibleValorIdx;
            idxDescricao = possibleDescricaoIdx;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho de Extrato Sicredi não encontrado. Verifique as colunas "DATA" e "VALOR".');
    }

    const extrato = [];
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        // Pular linhas de saldo ou totais
        const linhaStr = linha.join(' ').toLowerCase();
        if (linhaStr.includes('saldo') || linhaStr.includes('total')) continue;

        const dataStr = String(linha[idxData] || '').trim();
        if (!dataStr) continue;

        const data = normalizarData(dataStr);
        if (!data) continue;

        let valorStr = String(linha[idxValor] || '').trim();
        if (!valorStr) continue;

        let valor = null;
        let tipoFallback = 'indefinido';

        if (valorStr.endsWith(' C') || valorStr.endsWith('C')) {
            tipoFallback = 'crédito';
            valorStr = valorStr.replace(/\s?C$/, '').trim();
        } else if (valorStr.endsWith(' D') || valorStr.endsWith('D')) {
            continue; // Nós ignoramos débitos na lógica original
        } else if (valorStr.startsWith('(') && valorStr.endsWith(')')) {
            continue; // Formato contábil de débito em planilhas XLS
        }

        valor = normalizarValor(valorStr);

        let descricao = idxDescricao !== -1 ? String(linha[idxDescricao] || '').trim() : '';
        let tipo = descricao || tipoFallback;

        if (valor !== null && valor > 0) {
            extrato.push({
                linha: i + 1,
                data: data,
                valor: valor,
                tipo: tipo,
                dataOriginal: dataStr,
                valorOriginal: valorStr
            });
        }
    }

    return extrato;
};
